<template>
  <div class="container">
    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <p v-if="message.data.meta" class='sc-message--meta' :style="{color: messageColors.color}">{{message.data.meta}}</p>
    </div>
    <div id="carousel-container">
      <row container :gutter="12">
        <column :xs="12" :md="6" :xl="4" class="d-flex" v-for="(option, idx) in options" :key="idx">
          <div class="slide-container">
            <div class="seguradora" :style="{ color: chatbotColors.sentMessage.bg }">{{ option.seguradora }}</div>
            <div class="valor-seguro-title">VALOR DO SEGURO</div>
            <div class="valor-seguro">{{ option.valor }}</div>
            <div class="franquia-title">FRANQUIA</div>
            <em class="franquia-content">(sob consulta)</em>
            <div class="produto-title">PRODUTO</div>
            <div class="produto">{{ option.produto }}</div>
            <div v-if="option.coberturas.length" class="coberturas-title">COBERTURAS</div>
            <div v-if="option.coberturas.length" class="coberturas-content">
              <table>
                <tr v-for="(cobertura, idy) in option.coberturas" :key="idy">
                  <td><b>{{ cobertura.key }}</b></td>
                  <td width="1" style="white-space: nowrap;">{{ cobertura.value }}</td>
                </tr>
              </table>
            </div>
            <a v-if="option.pdf" :href="option.pdf" target="_blank" class="botao btn-pdf-cotacao" :style="{ border: `1px solid ${chatbotColors.sentMessage.bg}`, color: chatbotColors.sentMessage.bg }">
              <font-awesome-icon icon="file-pdf" class="icon" /> PDF DA COTAÇÃO
            </a>
            <button type="button" :disabled="optionSelected" @click.prevent="selectOption(option)" class="botao" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }">CLIQUE PARA SABER MAIS</button>
          </div>
        </column>

        <column :xs="12" :md="6" :xl="4" class="d-flex" v-if="loadingCalculos">
          <div class="slide-container loader">
            <Loading :chatbotColors="chatbotColors"></Loading>
          </div>
        </column>
      </row>
    </div>
  </div>
</template>

<script>
import Loading from '../components/Loading'
import escapeGoat from 'escape-goat'
import store from "./../store/"

export default {
  components: {
    Loading
  },
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      store,
      optionSelected: null,
      options: [],
      loadingCalculos: true,
      attempts: 0,
      maxAttempts: 30
    }
  },
  computed: {
    messageText() {
      // if (this.message.data.options.length === 0) {
      //   return 'Infelizmente não conseguimos trazer nenhum resultado. Tente novamente mais tarde!';
      // }

      const escaped = this.me
        ? escapeGoat.escape(this.message.data.text)
        : this.message.data.text;

      return escaped;
    }
  },
  watch: {
    attempts (value) {
      if (value >= this.maxAttempts) {
        this.loadingCalculos = false;
      }
    }
  },
  mounted () {
    this.loadCalculos();
  },
  methods: {
    selectOption (option) {
      this.loadingCalculos = false;
      this.optionSelected = option;

      window.EventBus.$emit('ON_MESSAGE_WAS_SENT', {
        author: 'me',
        type: 'text',
        bot: true,
        data: { key: null, text: `Quero saber mais sobre o seguro: ${option.seguradora} - ${option.produto} - ${option.valor}`, metadata: option }
      });
    },
    loadCalculos () {
      if (this.loadingCalculos === false) {
        return;
      }

      window.axios.post('/v1/resultado-residencial/calculos', {
        conversa_token: this.$store.state.conversaToken,
      }).then(response => {
        this.options = response.data;
        this.attempts++;

        setTimeout(() => {
          this.loadCalculos();
        }, 4000);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
a.chatLink {
  color: inherit !important;
}
.container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.d-flex {
  display: flex;
}
#carousel-container {
  width: 100%;
  margin-top: 10px;
}
.slide-container {
  width: 100%;
  min-height: 200px;
  padding: 21px;
  border-radius: 20px;
  background: #f1f1f1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  &.loader {
    justify-content: center;
  }

  .seguradora {
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
    background: #fff;
    border-radius: 10px;
    padding: 5px 0;
  }
  .produto-title {
    margin-top: 10px;
    font-size: 0.8rem;
    font-weight: bold;
    color: #777;
  }
  .produto {
    font-size: 0.8rem;
  }
  .franquia-title,
  .coberturas-title {
    margin-top: 10px;
    font-size: 0.8rem;
    font-weight: bold;
    color: #777;
  }
  .franquia-content {
    font-size: 0.8rem;
    margin-bottom: 10px;
  }
  .coberturas-content {
    margin-bottom: 10px;
  }
  .valor-seguro-title {
    margin-top: 10px;
    font-size: 0.8rem;
    font-weight: bold;
    color: #777;
  }
  .valor-seguro {
    font-size: 1.3rem;
    font-weight: bold;
    color: #333;
  }
}
.botao {
  display: inline-block;
  margin-top: 10px;
  padding: 8px 15px;
  border: 0;
  border-radius: 20px;
  font-size: 0.8rem;
  text-decoration: none;
  text-align: center;
  cursor: pointer;

  &:hover {
    opacity: .8;
  }

  &:disabled {
    opacity: .5;
    cursor: not-allowed;
    pointer-events: all !important;
  }
}
.btn-pdf-cotacao {
  .icon {
    margin-right: 5px;
  }
}
</style>
